export const mapHomeIndexToDataTable = (data) => {
  let result = data.map((item) => ({
    ...item,
    categoryName: item.category?.name || "",
    queryType: item.queryType?.name || "",
    devTypeCodeStr: item.devTypeCodes?.join(","),
    devSubTypeCodeStr: item.devSubTypeCodes?.join(","),
    context: item.isContext ? "True" : "False",
  }));

  return result;
};

export const homeIndexColumns = [
  { key: "categoryName", label: "Category Name", align: "center" },
  { key: "devTypeCodeStr", label: "DevSubTypeCode", align: "center" },
  { key: "devSubTypeCodeStr", label: "devSubTypeCode", align: "center" },
  { key: "queryType", label: "Query Type", align: "center" },
  { key: "description", label: "Description", align: "center" },
  { key: "context", label: "context", align: "center" },
];
